import { useAuthStore } from '../store/authStore';
import { authService } from '../services/authService';

export const useAuth = () => {
  const { user, tokens, isAuthenticated, setAuth, logout, setTokens } = useAuthStore();

  const handleLogin = async (email: string, password: string) => {
    const result = await authService.login({ email, password });
    console.log('🔐 useAuth.handleLogin - Setting auth with:', { user: result.user, hasAccessToken: !!result.tokens?.accessToken });
    setAuth(result.user, result.tokens);
    console.log('🔐 useAuth.handleLogin - Auth state updated');
    return result;
  };

  const handleSignup = async (email: string, password: string, name: string) => {
    const result = await authService.signup({ email, password, name });
    setAuth(result.user, result.tokens);
    return result;
  };

  const handleLogout = () => {
    logout();
  };

  const handleRefreshToken = async () => {
    if (!tokens?.refreshToken) {
      logout();
      throw new Error('No refresh token available');
    }

    const newTokens = await authService.refreshToken(tokens.refreshToken);
    setTokens(newTokens);
    return newTokens;
  };

  return {
    user,
    tokens,
    isAuthenticated,
    handleLogin,
    handleSignup,
    handleLogout,
    handleRefreshToken,
  };
};
